import React, { useEffect, useState, useRef } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Form } from "react-bootstrap";
import { DEFAULT_SUMMARY_MESSAGE } from '../../../constants'
import { useLazyQuery } from "@apollo/client";
import { useInitFbSDK } from "../../../helpers/fb-hooks";
import { errorTitleWithTextSwal } from "../../../helpers/sweetalert";
import { useToasts } from "react-toast-notifications";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import MessengerIcon from "../../../components/MessengerIcon";
import ErrorPermissionModal from "../../../components/ErrorPermissionModal";

function LiveDetailMessenger({ selectedUserOrder, closeMessengerModal }) {
    const { history } = useReactRouter()
    const { addToast } = useToasts()
    const isFbSDKInitialized = useInitFbSDK();

    const [fbUserAccessToken, setFbUserAccessToken] = useState();
    const [assignedPage, setAssignedPage] = useState();
    const [userConfirm, setUserConfirm] = useState();
    const [shopSettings, setShopSettings] = useState([]);
    const [message, setMessage] = useState(DEFAULT_SUMMARY_MESSAGE);
    const [isLoading, setIsLoading] = useState(false);
    const [showErrorPermissionModal, setShowErrorPermissionModal] = useState(false);

    const [getUserConfirmData, { data: userConfirmData }] = useLazyQuery(GET_USER_CONFIRMS, { fetchPolicy: "cache-and-network" });
    const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });

    React.useEffect(() => {
        connectFacebook()
        getUserConfirmData({
            variables: {
                where: {
                    pageId: selectedUserOrder?.pageId,
                    name: selectedUserOrder?.cfName,
                }
            }
        })
        initSetting()
    }, [isFbSDKInitialized]);

    React.useEffect(() => {
        // console.log(userConfirmData)
        if (userConfirmData) {
            setUserConfirm(userConfirmData.userConfirms.data[0])
            setIsLoading(false)
        }
    }, [userConfirmData]);

    useEffect(() => {
        if (shopSettingData && shopSettingData?.settings?.data?.length > 0) {
            setShopSettings(shopSettingData?.settings?.data[0])
        }
    }, [shopSettingData])

    const initSetting = async () => {
        setIsLoading(true)
        let SHOP_ID = await localStorage.getItem("SHOP");
        await getSettings({
            variables: {
                where: {
                    shop: SHOP_ID
                },
                orderBy: "createdAt_ASC"
            }
        })
    }


    const connectFacebook = async () => {

        // Checks if the user is logged in to Facebook
        window.FB.getLoginStatus((response) => {
            // console.log(response)
            if (response.authResponse) setFbUserAccessToken(response.authResponse?.accessToken);
            else window.FB.login((response) => {
                let hasPermission = true;
                ["public_profile", "email", "pages_read_engagement", "pages_show_list", "pages_messaging", "pages_manage_metadata", "pages_read_user_content"].map((_permisision) => {
                    if (!response.authResponse.grantedScopes.includes(_permisision)) hasPermission = false;
                })
                if (!hasPermission) {
                    addToast("ທ່ານຕ້ອງເປີດອະນຸຍາດໃຫ້ເຂົ້າເຖິງຂໍ້ມູນບໍ່ຄົບຖ້ວນ", {
                        appearance: "error",
                        autoDismiss: true,
                    });
                    setShowErrorPermissionModal(true)
                    return;
                }
                addToast("ເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກສໍາເລັດ", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                if (response.authResponse) setFbUserAccessToken(response.authResponse.accessToken);
                else errorTitleWithTextSwal("ມີຂໍ້ຜິດພາດ", "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ")
            }, {
                scope: `public_profile,email,
                         pages_show_list,
                         pages_read_engagement,
                         pages_messaging,
                         pages_manage_metadata,
                         pages_read_user_content`,
                return_scopes: true,
                auth_type: "rerequest"
            });
        });
    }

    // Fetches user pages
    React.useEffect(() => {
        if (fbUserAccessToken) {
            window.FB.api(
                `/me/accounts?access_token=${fbUserAccessToken}`,
                async ({ data }) => {
                    // console.log({ data })
                    // console.log({ selectedUserOrder })
                    let _seletedPage = data.filter((page) => page.id == selectedUserOrder.pageId)
                    setAssignedPage(_seletedPage[0])
                }
            );

        }
    }, [fbUserAccessToken]);

    const _sendMessenger = () => {
        closeMessengerModal()
        let cfText
        let total = 0
        selectedUserOrder.orders.map((cf, index) => {
            cfText = (cfText ? cfText : "") + (index + 1) + " : " + cf.productName + " ( x1 ) :  " + new Intl.NumberFormat('en-US').format(cf.price) + ` ກີບ \n`
            total = total + cf.price
        })
        let settingMessage = message;
        var _variableList = settingMessage.match(/\{\{.+?\}\}/g)
        let _bankData = (shopSettings && shopSettings.bank) ? JSON.parse(shopSettings.bank) : ""
        if (_variableList && _variableList.length > 0) _variableList.map((x, index) => {
            if (x.includes("cfText")) settingMessage = settingMessage.replace(x, cfText);
            if (x.includes("total")) settingMessage = settingMessage.replace(x, new Intl.NumberFormat('en-US').format(total));
            if (x.includes("bankName")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankName) ? _bankData.bankName : "");
            if (x.includes("bankAccount")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankAccount) ? _bankData.bankAccount : "");
            if (x.includes("bankUser")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankUser) ? _bankData.bankUser : "");
        })

        let params = {
            "messaging_type": "MESSAGE_TAG",
            "tag": "POST_PURCHASE_UPDATE",
            "recipient": {
                "id": userConfirm?.psid
            },
            "message": {
                "text": settingMessage
            }
        }
        window.FB.api(`/me/messages?access_token=${assignedPage?.access_token}`, "POST", params, async (res) => {
            // console.log(res)
            closeMessengerModal()
            addToast("ສົ່ງຂໍ້ຄວາມຫາລູກຄ້າສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        })
    }

    return (
        <div>
            <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Control
                    as="textarea" rows={15}
                    placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຕ້ອງການຈະສົ່ງຫາລູກຄ້າ..."
                    value={message || ""}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </Form.Group>

            {isLoading ? <div>ກໍາລັງໂຫຼດຂໍ້ມູນ</div> : <div onClick={() => { _sendMessenger() }} style={{ border: "1px solid #1877f2", color: "#1877f2", borderRadius: 12, width: 180, padding: 8, display: "flex", flexDirection: "row", justifyContent: "center", cursor: "pointer" }}>
                <MessengerIcon style={{ color: "#1877f2", fontSize: 20 }} />
                <div style={{ width: 12 }} />
                <p style={{ margin: 0 }}>ສົ່ງຂໍ້ຄວາມ</p>
            </div>}

            <ErrorPermissionModal showErrorPermissionModal={showErrorPermissionModal} setShowErrorPermissionModal={setShowErrorPermissionModal} />
        </div >
    );
}

export default LiveDetailMessenger;